import { render } from "./MenuButtonIcon.vue?vue&type=template&id=1e49c4df&scoped=true"
import script from "./MenuButtonIcon.vue?vue&type=script&lang=js"
export * from "./MenuButtonIcon.vue?vue&type=script&lang=js"

import "./MenuButtonIcon.vue?vue&type=style&index=0&id=1e49c4df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e49c4df"]])

export default __exports__